import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import "../../styles/dash/CreateOrEditChatBot.css";
import LoadingSpinner from "../utility/LoadingSpinner";


interface Role {
  id: number;
  name: string;
  status: number;
}

interface Props {
  role: Role | null;
  show: boolean;
  onClose: () => void;
  onSave: (newName: string) => Promise<void>;
}

interface ApiError {
  response?: {
    data?: string;
  };
}

const EditRoleNameModal: React.FC<Props> = ({ role, show, onClose, onSave }) => {
  const [newName, setNewName] = useState("");
  const [animateOut, setAnimateOut] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  
  const handleClose = () => {
    setAnimateOut(true);
    setTimeout(() => {
      onClose();
      setAnimateOut(false);
      setErrorMessage("");
    }, 300);
  };

  const handleSubmit = async () => {
    if (!newName.trim()) {
      setErrorMessage("El nombre no puede estar vacío");
      return;
    }

    setLoading(true);
    setErrorMessage("");

    try {
      await onSave(newName);
      handleClose();
    } catch (error: unknown) {
      const apiError = error as ApiError;
      setErrorMessage(apiError.response?.data || "Error al guardar el rol");
      console.error("Error al guardar el rol:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (role) {
      setNewName(role.name);
    } else {
      setNewName("");
    }
  }, [role]);

  if (!show && !animateOut) return null;

  return (
    <Modal
      show={!animateOut}
      onHide={handleClose}
      centered
      backdrop="static"
      contentClassName={`chatbot-form-modal ${animateOut ? 'modal-exit' : 'modal-enter'}`}
    >
      <Modal.Header closeButton closeVariant="white" className="border-0" />

      <Modal.Body className="chatbot-form-content">
        <h5 className="form-title text-center mb-4">
          Editar Nombre del Rol
        </h5>

        <Form>
          {loading && <LoadingSpinner />}

          <div className="form-grid">
            <div className="form-group full-width">
              <label>Nuevo nombre</label>
              <input
                type="text"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                placeholder="Ej: Administrador"
                className="w-100"
              />
            </div>

            {errorMessage && (
              <div className="error-message full-width">
                {errorMessage}
              </div>
            )}

            <div className="form-group full-width mt-3">
              <button
                type="button"
                className="save-button"
                onClick={handleSubmit}
              >
                GUARDAR CAMBIOS
              </button>
            </div>

            <div className="form-group full-width text-center">
              <button 
                type="button" 
                className="cancel-button" 
                onClick={handleClose}
              >
                Cancelar
              </button>
            </div>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditRoleNameModal;